import { useEffect } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router";

export function AuthLayout() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return (
    <div
      className="flex min-h-dvh flex-col overflow-x-clip"
      style={{ paddingTop: "var(--safe-area-inset-top)" }}
    >
      <main className="flex flex-1 flex-col">
        <header
          className="sticky z-30 flex h-12 shrink-0 items-center border-b border-border bg-background px-4"
          style={{ top: "var(--safe-area-inset-top)" }}
        >
          <span className="text-base font-semibold text-primary">
            Reframe
          </span>
        </header>
        <Outlet />
      </main>
    </div>
  );
}
